import { render } from "./download-document-list.vue?vue&type=template&id=500f5406&scoped=true&ts=true"
import script from "./download-document-list.vue?vue&type=script&lang=ts"
export * from "./download-document-list.vue?vue&type=script&lang=ts"

import "./download-document-list.vue?vue&type=style&index=0&id=500f5406&lang=scss&scoped=true"

import exportComponent from "C:\\Build\\vsts-agent-win-x64-3.218.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500f5406"]])

export default __exports__